import { createSlice } from '@reduxjs/toolkit';
import { cancelSubscription, createNewSubscription, getActiveSubscriptions } from './subscriptionServices';

const initialState = {
    subscriptionDetails: {
        isSubscriptionCreating: null,
        isSubscriptionSuccess: null,
        subscriptionMessage: null,
        subscriptionResponse: null,
    },
    activeSubscriptions: {
        isSubscriptionsLoading: null,
        isSubscriptionsSuccess: null,
        subscriptionsMessage: null,
        subscriptions: [],
    },
    removeSubscription: {
        isCancelling: null,
        isCancelSuccess: null,
        subscriptionCancelMessage: null
    },
}

const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(createNewSubscription.pending, (state) => {
            state.subscriptionDetails = {
                ...initialState.subscriptionDetails,
                isSubscriptionCreating: false,
                subscriptionMessage: 'Creating the subscription...',
            };
        })
        .addCase(createNewSubscription.rejected, (state, action) => {
            state.subscriptionDetails = {
                ...initialState.subscriptionDetails,
                isSubscriptionCreating: false,
                isSubscriptionSuccess: false,
                subscriptionMessage: action.payload.message,
            };
        })
        .addCase(createNewSubscription.fulfilled, (state, action) => {
            state.subscriptionDetails = {
                ...initialState.subscriptionDetails,
                isSubscriptionCreating: false,
                isSubscriptionSuccess: true,
                subscriptionMessage: action.payload.message,
                subscriptionResponse: action.payload.subscription
            };
        })

        builder
        .addCase(getActiveSubscriptions.pending, (state) => {
            state.activeSubscriptions = {
                ...initialState.activeSubscriptions,
                isSubscriptionsLoading: true,
                subscriptionsMessage: "Loading subscriptions...",
            };  
        })
        .addCase(getActiveSubscriptions.rejected, (state, action) => {
            state.activeSubscriptions = {
                ...initialState.activeSubscriptions,
                isSubscriptionsLoading: false,
                isSubscriptionsSuccess: false,
                subscriptionsMessage: action.payload.message,
            };  
        })
        .addCase(getActiveSubscriptions.fulfilled, (state, action) => {
            state.activeSubscriptions = {
                ...initialState.activeSubscriptions,
                isSubscriptionsLoading: false,
                isSubscriptionsSuccess: true,
                subscriptionsMessage: action.payload.message,
                subscriptions: action.payload
            };  
        })

        //Cancel subscription
        builder
        .addCase(cancelSubscription.pending, (state) => {
            state.removeSubscription = {
                ...initialState.removeSubscription,
                isCancelling: true,
                subscriptionCancelMessage: 'Cancelling the subscription...'
            }; 
        })
        .addCase(cancelSubscription.rejected, (state, action) => {
            state.removeSubscription = {
                ...initialState.removeSubscription,
                isCancelling: false,
                isCancelSuccess: false,
                subscriptionCancelMessage: action.payload.message,
            }; 
        })
        .addCase(cancelSubscription.fulfilled, (state, action) => {
            state.removeSubscription = {
                ...initialState.removeSubscription,
                isCancelling: false,
                isCancelSuccess: true,
                subscriptionCancelMessage: action.payload.message,
            };  
        })
    }
});

export default subscriptionSlice.reducer;